import { mapCookiePolicy } from '@websrc/DataMappers/mapCookiePolicy'
import { mapFooter } from '@websrc/DataMappers/mapFooter'
import React, { FC } from 'react'

import { FooterColor } from './Color/FooterColor'
import { FooterCTA } from './CTA/FooterCTA'
import { FooterPrivacy } from './FooterPrivacy'
import { FooterLink } from './Link/FooterLink'

export interface FooterProps {
  footer: ReturnType<typeof mapFooter>
  cookiePolicy: ReturnType<typeof mapCookiePolicy>
}

export const Footer: FC<FooterProps> = ({ footer, cookiePolicy }) => (
  <footer id={'main-footer'}>
    {!footer.hideFooterCTA && <FooterCTA cta={footer.cta} />}
    {!footer.hideFooterColor && <FooterColor color={footer.color} />}
    {!footer.hideNavigation && <FooterLink links={footer.links} />}
    <FooterPrivacy
      cookiePolicy={cookiePolicy}
      copyright={footer.copyright}
      policy={footer.policy}
    />
  </footer>
)
